import * as actionTypes from "./actionTypes";
import initialState from "reducers/initialState";

const leasingContractsReducer = (state = initialState.document.leasingContracts, action) => {
  switch (action.type) {
    case actionTypes.LOAD_CONTRACT_LIST_STARTED: {
      const { key, page } = action;
      let result = { ...state };
      result[key] = { ...state[key] };
      result[key][page] = { ...result[key][page], loading: true, loaded: false };
      return result;
    }
    case actionTypes.LOAD_CONTRACT_LIST_SUCCEEDED: {
      const { key, page, totalCount, totalPages } = action;
      let result = { ...state };
      result[key] = { ...state[key], totalCount, totalPages };
      result[key][page] = { ...result[key][page], ids: [...action.result], loading: false, loaded: true };
      return result;
    }
    case actionTypes.LOAD_CONTRACT_LIST_FAILED: {
      const { key, page } = action;
      let result = { ...state };
      result[key] = { ...state[key] };
      result[key][page] = { ...result[key][page], loading: false, loaded: false };
      return result;
    }
    case actionTypes.EMPTY_CONTRACTS_FOR_RESTRUCTURING: {
      const { key } = action;
      let result = { ...state };
      result[key] = {};
      return result;
    }
    case actionTypes.SAVE_CONTRACT_LIST_FILTERS: {
      const { filters } = action;
      let result = { ...state };
      result.filters = filters;
      return result;
    }
    case actionTypes.SAVE_LEASING_CONTRACT_SUCCEEDED: {
      return {};
    }

    default:
      return state;
  }
};

export default leasingContractsReducer;
